import React from 'react';
import { EEthereumNetworkId } from '@ankr.com/provider';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { makeStyles } from 'tss-react/mui';

import { useChainData } from 'modules/common';

interface Props {
  name: string;
  chainId: EEthereumNetworkId;
}

export function NameCell({ name, chainId }: Props): JSX.Element {
  const { classes } = useStyles();
  const chainData = useChainData(chainId);

  const networkName = chainData?.name || '';
  const networkIcon = chainData?.icon.rounded || '';

  return (
    <div className={classes.name}>
      {networkIcon && <img src={networkIcon} alt="" />}

      <Box display="flex" flexDirection="column" ml={2}>
        <Typography
          variant="subtitle3"
          sx={theme => ({
            color: theme.palette.primary.main,
            wordBreak: 'break-all',

            [theme.breakpoints.down('sm')]: {
              textAlign: 'right',
            },
          })}
        >
          {name}
        </Typography>

        <Typography
          variant="body3"
          sx={theme => ({
            mt: 1,
            color: theme.palette.grey[500],

            [theme.breakpoints.down('sm')]: {
              textAlign: 'right',
            },
          })}
        >
          {networkName}
        </Typography>
      </Box>
    </div>
  );
}

const useStyles = makeStyles()(theme => ({
  name: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(5),

    [theme.breakpoints.down('md')]: {
      flexDirection: 'row-reverse',
    },
  },
}));
